var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "12px",
    viewBox: "0 0 10 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fill: "#AAAAAA",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.61875,0.354 C6.38125,0.126 6.0625,0 5.73125,0 L1.25,0 C0.5625,0 0,0.54 0,1.2 L0,10.8 C0,11.46 0.55625,12 1.24375,12 L8.75,12 C9.4375,12 10,11.46 10,10.8 L10,4.098 C10,3.78 9.86875,3.474 9.63125,3.252 L6.61875,0.354 Z M6.875,9.6 L3.125,9.6 C2.78125,9.6 2.5,9.33 2.5,9 C2.5,8.67 2.78125,8.4 3.125,8.4 L6.875,8.4 C7.21875,8.4 7.5,8.67 7.5,9 C7.5,9.33 7.21875,9.6 6.875,9.6 Z M6.875,7.2 L3.125,7.2 C2.78125,7.2 2.5,6.93 2.5,6.6 C2.5,6.27 2.78125,6 3.125,6 L6.875,6 C7.21875,6 7.5,6.27 7.5,6.6 C7.5,6.93 7.21875,7.2 6.875,7.2 Z M5.625,3.6 L5.625,0.9 L9.0625,4.2 L6.25,4.2 C5.90625,4.2 5.625,3.93 5.625,3.6 Z",
    id: "Shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.ef90cd53394b629df2c492b405879384.svg";
export { ForwardRef as ReactComponent };